import '@/styles/main.scss';

import { createVuetify } from 'vuetify';
import { getHexColor } from '@loadsmart/miranda-wc/dist/tokens';
import { satelliteGlobalThemeColors, satelliteOpts } from '@satellite/plugins/vuetify';

// Luna is built with Miranda web components, so its Vuetify components take Miranda's tokens
// (satellite's palette and field style are Helios').
const mirandaThemeColors = {
  primary: getHexColor('color-primary-60'),
  error: getHexColor('color-danger-60'),
  success: getHexColor('color-success-60'),
  warning: getHexColor('color-warning-60'),
  background: getHexColor('color-background-secondary'),
  surface: getHexColor('color-background-primary'),
  'on-background': getHexColor('color-text-primary'),
  'on-surface': getHexColor('color-text-primary'),
  tag: getHexColor('color-background-tertiary'),
  'on-tag': getHexColor('color-text-tertiary'),
  'field-border': getHexColor('color-border-input'),
  'field-label': getHexColor('color-text-tertiary'),
  'field-focus': getHexColor('color-primary-100')
};

export const globalThemeColors = {
  ...satelliteGlobalThemeColors,
  ...mirandaThemeColors
};

// Outlined at Miranda's 40px field height; the unfocused border color is set in main.scss.
// Like Miranda's field hint, the message row under the box only takes space when it has text.
const mirandaField = {
  variant: 'outlined',
  density: 'compact',
  color: 'field-focus',
  hideDetails: 'auto'
};

const { defaults } = satelliteOpts;

const opts = {
  ...satelliteOpts,
  defaults: {
    ...defaults,
    VTextField: { ...defaults.VTextField, ...mirandaField },
    VTextarea: { ...defaults.VTextarea, ...mirandaField },
    VSelect: { ...defaults.VSelect, ...mirandaField },
    VAutocomplete: { ...defaults.VAutocomplete, ...mirandaField },
    VCombobox: { ...defaults.VCombobox, ...mirandaField },
    // Miranda's m-tag, in the label shape.
    VChip: { ...defaults.VChip, color: 'tag', label: true, density: 'comfortable' }
  },
  theme: {
    ...satelliteOpts.theme,
    themes: {
      ...satelliteOpts.theme.themes,
      opendockTheme: { ...satelliteOpts.theme.themes.opendockTheme, colors: globalThemeColors }
    }
  }
};

export default createVuetify(opts, { customProperties: true });
